<template>
  <v-container fluid id="docForm">
    <v-row dense>
      <v-col cols="8">
        <v-data-table
          light
          dense
          :items-per-page="pageItems"
          :headers="headers"
          :items="priceList"
          item-key="o_i_t_m_s_id"
          hide-default-footer
          disable-sort
        >
          <template v-slot:item.Name="{ item }">
            <v-autocomplete
              name="multipleOPLNProduct"
              v-if="itm4.length > 0"
              style="width: 400px"
              dense
              outlined
              single-line
              v-model="item.id"
              :items="itm4"
              label="Select Product"
              item-text="product.Name"
              item-value="id"
              @change="setListItem(item)"
            ></v-autocomplete>
          </template>

          <template v-slot:item.SellingPrice="{ item }">
            <v-text-field
              outlined
              dense
              name="multipleOPLNPrice"
              v-model="item.SellingPrice"
            ></v-text-field>
          </template>

          <!-- action template -->
          <template v-slot:item.action="{ item }">
            <v-btn @click="deleteRow(item)" color="red" icon>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <!-- end -->
        </v-data-table>

        <v-btn @click="addRow" small color="primary" class="mt-1">
          <v-icon left>mdi-plus</v-icon>Add Row
        </v-btn>
      </v-col>

      <v-col cols="8">
        <v-btn
          @click="save"
          :loading="loader"
          style="margin-top: -40px; margin-right: 40px"
          color="accent"
          class="float-right"
          >Update</v-btn
        >
      </v-col>
    </v-row>

    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      pageItems: 100,
      loader: false,
      currentOpln: null,
      headers: [
        { text: "Product", value: "Name" },
        { text: "Selling Price", value: "SellingPrice" },
        { text: "Action", value: "action" },
      ],
      priceList: [],
      itm4: [],
    };
  },
  watch: {
    "$route.params.id": {
      handler: "getPriceList",
      immediate: true,
    },
  },
  methods: {
    getPriceList(val) {
      const self = this;
      this.currentOpln = val;
      this.$store
        .dispatch("get", `/price-list/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.itm4 = res.ResponseData.itm4;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    deleteRow(item) {
      const selectedRow = this.priceList.find((record) => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.priceList.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.priceList.splice(pos, 1);
    },
    save() {
      const url = `/price-list-update-multiple`;
      const data = {
        priceList: this.priceList,
      };
      this.loader = true;
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$router.push(`/price-lists/manage/${self.currentOpln}`);
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    setListItem(data) {
      const selectedItm4 = this.itm4.find((record) => {
        return record.id === data.id;
      });

      const existingData = this.priceList.find((record) => {
        return record.o_i_t_m_s_id === selectedItm4.o_i_t_m_s_id;
      });

      if (existingData == undefined) {
        const currentItem = this.priceList.find((record) => {
          return record.LineNum === data.LineNum;
        });

        const pos = this.priceList.indexOf(currentItem);

        if (pos === -1) {
          return;
        }

        currentItem.SellingPrice = selectedItm4.SellingPrice;
        currentItem.o_i_t_m_s_id = selectedItm4.o_i_t_m_s_id;
        this.priceList[pos] = currentItem;
      } else {
        this.$refs.snackbar.show(
          "That product already exist in the list!",
          "red"
        );
      }
    },
    addRow() {
      let initArray = [];
      const LineNum = new Date().getTime();
      let details = {
        Name: null,
        SellingPrice: null,
        LineNum: LineNum,
        o_i_t_m_s_id: null,
      };
      initArray.push(details);
      this.priceList = [...this.priceList, ...initArray];
    },
    setDefaultRow() {
      let initArray = [];
      const LineNum = new Date().getTime();
      let details = {
        Name: null,
        SellingPrice: null,
        LineNum: LineNum,
        o_i_t_m_s_id: null,
      };
      initArray.push(details);
      this.priceList = [...this.priceList, ...initArray];
    },
  },
  created() {
    this.setDefaultRow();
  },
};
</script>

<style lang="scss" scoped>
</style>